// import React, { useState } from 'react';
// import './Login.css';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import axiosInstance, { postData } from '../../services/FetchNodeServices';

// const Login = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [step, setStep] = useState(1); // 1: login, 2: forgot password

//   const handleLogin = async (e) => {
//     e.preventDefault();
//    try {
//      const response = await axiosInstance.post('/api/v1/auth/admin-login', { email, password });
//      if(response.status===200){
//       toast.success('Login successfully!');
//       navigate("/");
//       window.location.reload();
//      }
//    } catch (error) {
//     console.log("sign up error",error);
//     toast.error(error?.response?.data?.message || 'Login failed');
//    }
    
    
//   };

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     if (!email) {
//       toast.error('Please enter your email first');
//       return;
//     }

//     // Simulate sending email logic here
//     const response = await postData('api/admin/send-reset-password-email', { email });
//     console.log("responseresponse:= ", response);
//     if (response?.status) {
//       toast.success('Reset link sent to your email');
//       setStep(1);
//     } else {
//       toast.error(response?.message || 'Failed to send reset link');
//     }
//   };

//   return (
//     <div className="main-login">
//       <div className="login-container">
//         <h2 className="login-title">
//           {step === 1 ? 'Admin Login' : 'Forgot Password'}
//         </h2>

//         {step === 2 && (
//           <div className="login-divider">Enter your email to receive a reset link</div>
//         )}

//         <form onSubmit={step === 1 ? handleLogin : handleForgotPassword} className="login-form">
//           <div className="form-group">
//             {step === 1 && (<label>Email</label>)}
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="form-control"
//               required
//             />
//           </div>

//           {step === 1 && (
//             <div className="form-group">
//               <label>Password</label>
//               <input
//                 type={showPassword ? 'text' : 'password'}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 className="form-control"
//                 required
//               />
//               <div className="show-password">
//                 <input
//                   type="checkbox"
//                   checked={showPassword}
//                   onChange={() => setShowPassword(!showPassword)}
//                   id="show-password-checkbox"
//                 />
//                 <label htmlFor="show-password-checkbox">Show Password</label>
//               </div>
//               {/* <div className="forgot-password">
//                 <p onClick={() => setStep(2)}>Forgot Password?</p>
//               </div> */}
//             </div>
//           )}

//           <button type="submit" className="login-button cursor-pointer">
//             {step === 1 ? 'Login' : 'Send Reset Link'}
//           </button>

//           {step === 2 && (
//             <div className="back-to-login">
//               <p onClick={() => setStep(1)}>← Back to Login</p>
//             </div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;



import React, { useState } from 'react';
import './Login.css';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axiosInstance, { postData } from '../../services/FetchNodeServices';

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail]               = useState('');
  const [password, setPassword]         = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep]                 = useState(1); // 1: login, 2: forgot password
  const [loading, setLoading]           = useState(false);

  // ── Login ──────────────────────────────────────────────────────────────────
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Please fill in all fields');
      return;
    }
    setLoading(true);
    try {
      const response = await axiosInstance.post('/api/v1/auth/admin-login', { email, password });
      if (response.status === 200) {
        toast.success('Login successfully!');
        navigate('/');
        window.location.reload();
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error?.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  // ── Forgot password ────────────────────────────────────────────────────────
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email');
      return;
    }
    setLoading(true);
    try {
      const response = await axiosInstance.post('/api/v1/auth/forgot-admin-password', { email });
      if (response?.status) {
        toast.success('Reset link sent! Check your email.');
        setStep(1);
        setEmail('');
      } else {
        toast.error(response?.message || 'Failed to send reset link');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // ── UI ─────────────────────────────────────────────────────────────────────
  return (
    <div className="main-login">
      <div className="login-container">
        <h2 className="login-title">
          {step === 1 ? 'Admin Login' : 'Forgot Password'}
        </h2>

        {step === 2 && (
          <div className="login-divider">
            Enter your email to receive a password reset link
          </div>
        )}

        <form
          onSubmit={step === 1 ? handleLogin : handleForgotPassword}
          className="login-form"
        >
          {/* Email */}
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="admin@example.com"
              required
            />
          </div>

          {/* Password (login step only) */}
          {step === 1 && (
            <div className="form-group">
              <label>Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control"
                  placeholder="Enter your password"
                  required
                />
                <button
                  type="button"
                  className="eye-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  tabIndex={-1}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>

              {/* Forgot password link */}
              <div className="forgot-password">
                <span onClick={() => { setStep(2); setPassword(''); }}>
                  Forgot Password?
                </span>
              </div>
            </div>
          )}

          {/* Submit */}
          <button
            type="submit"
            className="login-button cursor-pointer"
            disabled={loading}
          >
            {loading
              ? (step === 1 ? 'Logging in…' : 'Sending…')
              : (step === 1 ? 'Login' : 'Send Reset Link')}
          </button>

          {/* Back to login */}
          {step === 2 && (
            <div className="back-to-login">
              <span onClick={() => setStep(1)}>← Back to Login</span>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;